export const toast_msessages = {
    emp_success: "Employee Added Successfully",
    emp_failure: "Unable to Add Employee",
    empedit_success: "Employee Details Edited Successfully",
    empedit_failure: "Unable to Edit Employee Details",
    empdelete_success: "Employee Details Deleted Successfully",
    empdelete_failure: "Unable to Delete Employee Details",
    emprfid_failure: "Unable to Add RFID to Employee. Please Retry",
    prdAdd_success: "Product Added Successfully",
    prdAdd_failure: "Unable to Add Product",
    prdedit_success: "Product Details Edited Successfully",
    prdedit_failure: "Unable to Edit Product Details",
    prddelete_success: "Product Details Deleted Successfully",
    prddelete_failure: "Unable to Delete Product Details",
    peelEntryAdd_success: "Peeling Entry Added Successfully",
    peelEntryAdd_failure: "Unable to Make Peeling Entry",
    stockEntryAdd_success: "Stock Entry Added Successfully",
    stockEntryAdd_failure: "Unable to Make Stock Entry",
    peelEntryedit_success: "Peeling Entry Details Edited Successfully",
    peelEntryedit_failure: "Unable to Edit Peeling Entry Details",
    stockEntryedit_success: "Stock Entry Details Edited Successfully",
    stockEntryedit_failure: "Unable to Edit Stock Entry Details",

}